// server for all hnc services
export const url = { API_URL: process.env.REACT_APP_SERVER };

export const notificationSocketUrl = {
  API_URL: process.env.REACT_APP_SERVER,
};

// server for team collaboration feature
export const socketUrl = { API_URL: process.env.REACT_APP_SOCKET_SERVER };
